import { Facebook, Linkedin, Send, Mail, Link2, MessageCircle, Share2 } from "lucide-react";
import { toast } from "sonner";

const XIcon = () => <span className="font-black text-sm leading-none">X</span>;
const RedditIcon = () => <span className="font-black text-[11px] leading-none">r/</span>;

export const shareUrlFor = (releaseId) => `${window.location.origin}/api/share/release/${releaseId}`;

const targets = (url, text) => {
  const u = encodeURIComponent(url), t = encodeURIComponent(text);
  return [
    { key: "facebook", label: "Facebook", Icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${u}` },
    { key: "x", label: "X", Icon: XIcon, href: `https://twitter.com/intent/tweet?url=${u}&text=${t}` },
    { key: "whatsapp", label: "WhatsApp", Icon: MessageCircle, href: `https://wa.me/?text=${t}%20${u}` },
    { key: "telegram", label: "Telegram", Icon: Send, href: `https://t.me/share/url?url=${u}&text=${t}` },
    { key: "linkedin", label: "LinkedIn", Icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${u}` },
    { key: "reddit", label: "Reddit", Icon: RedditIcon, href: `https://www.reddit.com/submit?url=${u}&title=${t}` },
    { key: "email", label: "Email", Icon: Mail, href: `mailto:?subject=${t}&body=${t}%0A${u}` },
  ];
};

export const SocialShare = ({ releaseId, text, prefix = "social-share" }) => {
  const url = shareUrlFor(releaseId);
  const copy = async () => { await navigator.clipboard.writeText(`${text} ${url}`); toast.success("Testo e link copiati: incollali su Instagram, TikTok o dove vuoi"); };
  const native = async () => { try { await navigator.share({ title: text, url }); } catch { /* user cancelled */ } };
  const btn = "h-10 min-w-10 px-3 rounded-full border border-white/20 bg-white/5 inline-flex items-center justify-center gap-1.5 text-xs font-semibold hover:border-emerald-400 hover:text-emerald-300 hover:-translate-y-0.5 transition-[color,border-color,transform]";
  return (
    <div className="flex flex-wrap gap-2" data-testid={prefix}>
      {targets(url, text).map(({ key, label, Icon, href }) => (
        <a key={key} href={href} target="_blank" rel="noopener noreferrer" aria-label={`Condividi su ${label}`} className={btn} data-testid={`${prefix}-${key}`}><Icon className="h-4 w-4" /><span className="hidden sm:inline">{label}</span></a>
      ))}
      <button type="button" onClick={copy} className={btn} data-testid={`${prefix}-copy`}><Link2 className="h-4 w-4" /> Copia</button>
      {typeof navigator !== "undefined" && navigator.share && <button type="button" onClick={native} className={btn} data-testid={`${prefix}-native`}><Share2 className="h-4 w-4" /> Altre app</button>}
    </div>
  );
};
